import { useStore } from 'react-redux';
import { getFormValues } from 'redux-form/immutable';
import { CHECKOUT_FORM_TITLE } from '../components/form/constants';
import type { CheckoutReduxForm } from '../types/checkout-redux-form';
import type { RootState } from '@ticketmaster/tm1pos-web-shared/store/store';

export const useLegacyCheckoutForm = (): (() => CheckoutReduxForm) => {
  const store = useStore<RootState>();

  return () => (getFormValues(CHECKOUT_FORM_TITLE, (state) => state.form)(store.getState()) as any).toJSON();
};
